import { useState, useEffect } from "react";
import welcomeGif from "../../assets/welcome.gif";
import { useImagePlacement } from "../../hooks/useImagePlacement";
import { Spinner } from "../common/Spinner";

interface HeroProps {
  onHeroLoaded: (loaded: boolean) => void;
}

export const Hero = ({ onHeroLoaded }: HeroProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [welcomeLoaded, setWelcomeLoaded] = useState(false);
  const [showMainImage, setShowMainImage] = useState(false);

  // メイン画像の取得
  const { imageUrls, isLoading, error } = useImagePlacement(2, {
    width: 650,
    height: 650,
    quality: 80,
  });

  // welcome.gifの取得
  const {
    imageUrls: welcomeImageUrls,
    isLoading: isWelcomeLoading,
    error: welcomeError,
  } = useImagePlacement(8, {});

  // welcomeの表示が完了したら、少し待ってからメイン画像を表示
  useEffect(() => {
    if (welcomeLoaded) {
      const timer = setTimeout(() => {
        setShowMainImage(true);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [welcomeLoaded]);

  // メイン画像のロードが完了したら、2000ms後にHeaderを表示
  useEffect(() => {
    if (imageLoaded) {
      const timer = setTimeout(() => {
        onHeroLoaded(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [imageLoaded, onHeroLoaded]);

  if (error) {
    console.error("メイン画像の取得に失敗しました:", error);
  }

  if (welcomeError) {
    console.error("ウェルカム画像の取得に失敗しました:", welcomeError);
  }

  if (isLoading || isWelcomeLoading) {
    return (
      <section className="min-h-screen flex items-center justify-center bg-white">
        <Spinner />
      </section>
    );
  }

  return (
    <section className="min-h-screen flex items-center justify-center bg-white">
      <div className="container mt-4 flex flex-col items-center justify-center gap-24">
        <div className="text-gray-800 text-center mt-20">
          {welcomeImageUrls[0] ? (
            <img
              src={welcomeImageUrls[0]}
              alt="Welcome"
              onLoad={() => setWelcomeLoaded(true)}
              className={`h-[180px] w-full mx-auto object-contain transition-opacity duration-[2000ms] ease-in ${
                welcomeLoaded ? "opacity-100" : "opacity-0"
              }`}
            />
          ) : (
            <img
              src={welcomeGif}
              alt="Welcome"
              onLoad={() => setWelcomeLoaded(true)}
              className={`h-[180px] w-full mx-auto object-contain transition-opacity duration-[2000ms] ease-in ${
                welcomeLoaded ? "opacity-100" : "opacity-0"
              }`}
            />
          )}
        </div>

        <div className="text-gray-800 text-center mt-0">
          <div className="flex flex-col items-center">
            {imageUrls[0] && showMainImage ? (
              <img
                src={imageUrls[0]}
                alt="main"
                onLoad={() => setImageLoaded(true)}
                className={`w-[650px] h-auto transition-all duration-[3000ms] ease-out 
                  ${
                    imageLoaded
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 translate-y-[120px]"
                  }`}
              />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};
